import api from '../utils/api';

/**
 * دریافت الگوی کدینگ کاربر (در صورت نبود، پیش‌فرض ایجاد می‌شود)
 */
export const getCodingPattern = async () => {
  const response = await api.get('/product-codings/pattern');
  return response.data;
};

/**
 * ویرایش الگوی کدینگ
 * @param {{ title?: string, separator?: string, levels?: Array<{ level: number, title: string, length: number, description?: string }> }} data
 */
export const updateCodingPattern = async (data) => {
  const response = await api.put('/product-codings/pattern', data);
  return response.data;
};

/**
 * دریافت یک سطح از کدینگ.
 * parentId=root فقط گروه‌های ریشه؛ parentId یک نود فقط فرزندان مستقیم؛
 * q جستجو (حداکثر ۴۰ نتیجه به‌همراه اجداد).
 */
export const getProductCodings = async (params = {}) => {
  const response = await api.get('/product-codings', { params });
  return response.data;
};

/**
 * ایجاد یک نود کدینگ جدید
 * @param {{ parentId?: string|null, shortcode: string, title: string, description?: string }} data
 */
export const createProductCoding = async (data) => {
  const response = await api.post('/product-codings', data);
  return response.data;
};

/**
 * ویرایش نود کدینگ
 * @param {string} id
 * @param {{ title?: string, description?: string, shortcode?: string }} data
 */
export const updateProductCoding = async (id, data) => {
  const response = await api.put(`/product-codings/${id}`, data);
  return response.data;
};

/**
 * حذف یک نود کدینگ و کلیه فرزندان آن
 * @param {string} id
 */
export const deleteProductCoding = async (id) => {
  const response = await api.delete(`/product-codings/${id}`);
  return response.data;
};

/**
 * اتصال یا قطع اتصال دستی یک نود به تنوع محصول
 * @param {string} id
 * @param {{ productId?: string, logicalVariantId?: string, disconnect?: boolean }} data
 */
export const connectVariant = async (id, data) => {
  const response = await api.post(`/product-codings/${id}/connect-variant`, data);
  return response.data;
};

/**
 * اجرای اتصال جمعی خودکار: تطبیق SKUهای تنوع منطقی با FullCode کدینگ‌های کالا
 */
export const bulkMatchVariants = async () => {
  const response = await api.post('/product-codings/bulk-match-variants');
  return response.data;
};

/**
 * حذف تنوع‌های منطقی که در درخت کدینگ نیستند (فقط با تطابق سخت فعال)
 */
export const purgeVariantsNotInCoding = async () => {
  const response = await api.post('/product-codings/purge-variants-not-in-coding');
  return response.data;
};
